import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { DisplayInputComponentProps } from '../../types';
import jamespot, { jFileLittle } from 'jamespot-user-api';
import type { FieldValues } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { Toast } from 'jamespot-front-business';

export const InputFile = <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
    const JRCInputFileAdvancedRaw = commonComponentsRegistry.getLazyComponent('InputFileAdvancedRaw');
    const { getValues } = useFormContext();
    const dispatch = useDispatch();
    const { formatMessage: t } = useIntl();
    const [existingFiles, setExistingFiles] = React.useState<jFileLittle[]>([]);

    React.useEffect(() => {
        const existingFiles = (getValues(props.name) ?? []) as jFileLittle[];
        setExistingFiles(existingFiles);
    }, [getValues, props.name]);

    const token = getValues('token');

    const deleteAttachment = React.useCallback(
        async (id: number) => {
            try {
                await jamespot.file.deleteFile(id, 'attachment', token ?? '');
            } catch (error) {
                dispatch(
                    Toast.actions.error({
                        label: t({ id: 'GLOBAL_Error' }),
                    }),
                );
            }
        },
        [dispatch, t, token],
    );

    return (
        <JRCInputFileAdvancedRaw
            {...props}
            multiple
            existingFiles={existingFiles}
            token={token}
            deleteFile={deleteAttachment}
            // onUploadSuccess={handleUploadSuccess}
        />
    );
};
